var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AddIcon from "@material-ui/icons/Add";
import BusinessIcon from "@material-ui/icons/Business";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@material-ui/lab";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
var FabButton = /** @class */ (function (_super) {
    __extends(FabButton, _super);
    function FabButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { open: false };
        return _this;
    }
    FabButton.prototype.render = function () {
        var _this = this;
        var currentUser = this.props.currentUser;
        var userLinks = (React.createElement("div", null,
            React.createElement(SpeedDial, { ariaLabel: "SpeedDial example", icon: React.createElement(SpeedDialIcon, null), onClose: function () { return _this.setState({ open: false }); }, onOpen: function () { return _this.setState({ open: true }); }, open: this.state.open },
                React.createElement(SpeedDialAction, { tooltipTitle: "Upload your video", icon: React.createElement(CloudUploadIcon, null), onClick: function () { return _this.props.history.push("/user/upload"); } }))));
        var adminLinks = (React.createElement(SpeedDial, { ariaLabel: "SpeedDial example", icon: React.createElement(SpeedDialIcon, null), onClose: function () { return _this.setState({ open: false }); }, onOpen: function () { return _this.setState({ open: true }); }, open: this.state.open },
            React.createElement(SpeedDialAction, { tooltipTitle: "Add user", icon: React.createElement(PersonAddIcon, null), onClick: function () { return _this.props.history.push("/agent"); } }),
            React.createElement(SpeedDialAction, { tooltipTitle: "Add product", icon: React.createElement(AddIcon, null), onClick: function () { return _this.props.history.push("/product"); } }),
            React.createElement(SpeedDialAction, { tooltipTitle: "Add enterprise", icon: React.createElement(BusinessIcon, null), onClick: function () { return _this.props.history.push("/newenterprise"); } })));
        var agentLinks = (React.createElement(SpeedDial, { ariaLabel: "SpeedDial example", icon: React.createElement(SpeedDialIcon, null), onClose: function () { return _this.setState({ open: false }); }, onOpen: function () { return _this.setState({ open: true }); }, open: this.state.open },
            React.createElement(SpeedDialAction, { tooltipTitle: "Upload Customer Video", icon: React.createElement(CloudUploadIcon, null), onClick: function () { return _this.props.history.push("/agent/upload"); } }),
            React.createElement(SpeedDialAction, { tooltipTitle: "Upload your own Video", icon: React.createElement(VideoLibraryIcon, null), onClick: function () { return _this.props.history.push("/agent/upload/area"); } }),
            React.createElement(SpeedDialAction, { tooltipTitle: "New order", icon: React.createElement(NoteAddIcon, null), onClick: function () { return _this.props.history.push("/order"); } }),
            React.createElement(SpeedDialAction, { tooltipTitle: "Add product", icon: React.createElement(AddIcon, null), onClick: function () { return _this.props.history.push("/product"); } })));
        var authButton = (React.createElement("div", { style: { position: "fixed", right: 23, bottom: 23, zIndex: 5 } }, (currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) === "customer" ? userLinks : (currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) === "agent" ? agentLinks : adminLinks));
        var guestButton = "";
        return currentUser ? authButton : guestButton;
    };
    return FabButton;
}(Component));
export default withRouter(FabButton);



//////////////////
// WEBPACK FOOTER
// ./src/components/common/FabButton.tsx
// module id = 712
// module chunks = 0